module.exports = __webpack_public_path__ + "img/payment-cod.c35c0f9b.svg";